import React from 'react';
import PropTypes from 'prop-types';
import { withLastLocation } from 'react-router-last-location';
import { GeneralErrorModal } from './index';


const RenderActiveModals = props => {
  const {
    //  openModal,
    closeModal, isModalOpen, modalData } = props;
    
  if (isModalOpen('raffleErrorModal')) {
    const { turnBackSantra, forceBackOnClose } = modalData.raffleErrorModal;
    return (
      <GeneralErrorModal
        turnBackSantra= { turnBackSantra }
        forceBackOnClose= { forceBackOnClose }
        modalClose={ () => {
          closeModal('raffleErrorModal');
        } }
      />
    );
  }
  
  return null;
};

RenderActiveModals.propTypes = {
  closeModal: PropTypes.func,
  openModal: PropTypes.func,
  isModalOpen: PropTypes.func,
  modalData: PropTypes.object
};

export default withLastLocation(RenderActiveModals);
